import { EmptyState, SearchIcon } from '@forge/common';

const NotFoundPage = () => (
  <div className="flex items-center justify-center" style={{ minHeight: '60vh' }}>
    <EmptyState
      icon={<SearchIcon />}
      title="Page Not Found"
      description="The page you are looking for does not exist or has been moved."
    />
  </div>
);

export default NotFoundPage;
